import { PhoneNumberUtil } from 'google-libphonenumber';
import { hasAccess, accessKeys } from "./userAccess";

const PNF = PhoneNumberUtil.getInstance();

export function validatePhoneNumber(phoneNumber) {
    const regionCode = getRegionCode();
    let parsedNumber;
    try {
      parsedNumber = PNF.parse(phoneNumber, regionCode)
    }
    catch {
      return false;
    }
    return PNF.isValidNumberForRegion(parsedNumber, regionCode);
}

function getRegionCode() {
    if (hasAccess(accessKeys.swedishCompany)) {
      return "SE";
    }
  
    if (hasAccess(accessKeys.englishCompany)) {
      return "GB";
    }
  
    if (hasAccess(accessKeys.frenchCompany)) {
      return "FR";
    }
  
    if (hasAccess(accessKeys.norwegianCompany)) {
      return "NO";
    }
  
    return "SE"
  }